const Session = {
  setItem: (key, value) => {
    if (typeof Storage !== 'undefined') {
      localStorage.setItem(key, value)
    }
  },

  getItem: (key) => {
    if (typeof Storage !== 'undefined') {
      return localStorage.getItem(key)
    }
    return null
  },

  hasItem: (key) => {
    if (typeof Storage !== 'undefined') {
      return (localStorage.getItem(key) !== null)
    }
    return false
  },

  removeItem: (key) => {
    if (typeof Storage !== 'undefined') {
      return localStorage.removeItem(key)
    }
    return null
  }
}

export default Session
